import { useHistory, useParams } from 'react-router-dom';
import { ProfileSelection } from './ProfileSelection';
import { useStyles } from './RegistrationForm.styles';
import { Grid } from '@material-ui/core';
import AdultForm from './AdultForm/AdultForm';
import { useNotificationModal } from '@room-match/shared-ui-components';
import { Success } from './Success';
import MinorForm from './MinorForm/MinorForm';
import React from 'react';
import { ROUTES } from 'shared/constants/ROUTES';

export const RegistrationForm = () => {
  const { container, body } = useStyles();
  const { adult_minor, step } = useParams() as { adult_minor: string; step: string };
  const { handleOpen, isOpen, NotificationModal, handleSetMessage, handleChangeModalType } = useNotificationModal({
    type: 'error',
  });

  const showError = (header: string, message: string, button_text: string) => {
    handleSetMessage(header, message, button_text);
    handleOpen();
  };

  const history = useHistory();

  const renderComponent = () => {
    switch (adult_minor) {
      case 'adult':
        return <AdultForm showError={showError} />;
      case 'minor':
        return <MinorForm showError={showError} />;
      case 'complete':
        return <Success />;
      default:
        return (
          <Grid item className={body}>
            <ProfileSelection />
          </Grid>
        );
    }
  };

  const processOnClose = () => {
    switch (adult_minor) {
      case 'adult':
        handleChangeModalType('error');
        break;
      case 'minor':
        switch (step) {
          case 'profile_image':
            history.push(ROUTES.MINOR_MEMBER_INFO);
            break;
          case '2':
            handleChangeModalType('error');
            break;
          default:
            handleChangeModalType('error');
            break;
        }
        break;
      default:
        handleChangeModalType('error');
        break;
    }
  };
  return (
    <Grid className={container}>
      {renderComponent()}
      {isOpen ? <NotificationModal onClose={processOnClose} /> : <React.Fragment />}
    </Grid>
  );
};
